import React, { useState, useEffect } from "react"
import { usePageContext } from "vike-react/usePageContext"
import AldooRouter from "aldoo-ra/Router"
import AldooPageRenderer from "aldoo-ra/AldooComponent/renderers/AldooPageRenderer.jsx"

function Page() {
  const pageContext = usePageContext()
  const [pathname, setPathname] = useState(
    typeof window !== "undefined" ? window.location.pathname : pageContext.urlPathname
  )

  useEffect(() => {
    const handlePopState = () => setPathname(window.location.pathname)
    window.addEventListener("popstate", handlePopState)
    return () => window.removeEventListener("popstate", handlePopState)
  }, [])

  // Keep in sync when Vike updates urlPathname via its own navigation
  useEffect(() => {
    setPathname(pageContext.urlPathname)
  }, [pageContext.urlPathname])

  const urlPathname = pathname
  let Component = AldooRouter.resolve(urlPathname)

  // Router may not have the route registered yet (e.g. page published after server start).
  // Fall back to the pageData resolved by onBeforeRender.
  if (!Component && pageContext.pageData) {
    return <AldooPageRenderer pageData={pageContext.pageData} />
  }

  if (!Component) {
    // If no component found, resolve the /404 route instead
    const NotFoundComponent = AldooRouter.resolve("/404")
    if (NotFoundComponent) {
      return <NotFoundComponent pageContext={pageContext} />
    }
    // Fallback if even /404 route doesn't exist
    return <div>404 - Page not found</div>
  }

  return <Component pageContext={pageContext} />
}

export default Page
